<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="summary container defaultSectionMargins">
    <div v-if="activeAccommodation" class="summary__IntroContent">
      <div class="summary__IntroTexts">
        <div>
          <div class="summary__BrandWrapper">
            <div>
              <Flare :srcset="activeAccommodation.brand.dark_logo" width="300" :alt="activeAccommodation.brand.dark_logo.alt" />
            </div>
          </div>

          <div v-if="data.description" v-html="data.description" />
        </div>

        <div class="summary__Contact">
          <Icon name="phone-call" />
          <div>
            <a v-if="page.phone_number" :href="`tel:${page.phone_number}`">{{ page.phone_number }}</a>
            <a v-if="page.email" :href="`mailto:${page.email}`">{{ page.email }}</a>
          </div>
        </div>
      </div>

      <ul v-if="activeAccommodation.usp_verticals?.length" class="summary__Ammenities">
        <li v-for="item in activeAccommodation.usp_verticals">
          <div v-if="item.image" class="summary__AmmenitiesImage">
            <Flare :srcset="item.image" width="72" height="72" size="both" crop="fill" :alt="item.image.alt" />
          </div>
          <template v-if="item.description">{{ item.description }}</template>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const { page } = usePage();
  const { accommodationsData } = useSetup();
  const activeAccommodation = computed(() => accommodationsData.value[page.value.id]);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_summary.scss');
</style>